var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm._f("moment")(this.params.data.createdAt,"calendar", "July 10 2011"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }